<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card v-if="tieneAcceso === false">
          <div slot="header">
            <strong>Cta Cte Beneficiarios</strong>
          </div>
          <b-row>
            <b-col lg="12">
              <p>Acceso restringido</p>
            </b-col>
          </b-row>
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Filtros del Informe</strong>
          </div>
          <b-row>
            
            <b-col  sm="2">  
              <b-form-group 
                :label="crearLabel('Código Beneficiario', 'codbeneficiario', 'datosFormulario')"
                label-for="codbeneficiario">
                <b-form-input size="sm"
                  id="codbeneficiario"
                  type="text"
                  placeholder=""
                  v-model="datosFormulario.codbeneficiario"
                  :disabled="campoBloqueado('codbeneficiario', 'datosFormulario')">
                </b-form-input>
                <span class="error-validacion-campo">
                    {{ mensajeValidacionCampo.codbeneficiario }}
                </span>
              </b-form-group>
            </b-col>

            <b-col sm="2">
              <b-form-group 
                :label="crearLabel('ID Nación Beneficiario', 'idnacion', 'datosFormulario')"
                label-for="idnacion">
                <b-form-input size="sm"
                  id="idnacion"
                  type="text"
                  placeholder=""
                  v-model="datosFormulario.idnacion"
                  :disabled="campoBloqueado('idnacion', 'datosFormulario')">
              </b-form-input>
              <span class="error-validacion-campo">
                    {{ mensajeValidacionCampo.idnacion }}
              </span>
              </b-form-group>
            </b-col>
            
            <b-col sm="3">
              <b-form-group 
                :label="crearLabel('Nombre Beneficiario', 'nombre', 'datosFormulario')"
                label-for="nombre">
                <b-form-input size="sm"
                  id="nombre"
                  type="text"
                  placeholder=""
                  v-model="datosFormulario.nombre"
                  :disabled="campoBloqueado('nombre', 'datosFormulario')">
                </b-form-input>
                <span class="error-validacion-campo">
                    {{ mensajeValidacionCampo.nombre }}
                </span>
              </b-form-group>
           </b-col>  

           <b-col sm="2">
              <b-form-group label=" ." label-class="label-blanco">
                <b-button size="sm" variant="primary" @click="modalBeneficiarios = true"><i class="fa fa-search"></i> Buscar Beneficiario</b-button>
              </b-form-group>
            </b-col>
             
          </b-row>

          <div slot="footer">
            <div class="form-actions">
              <el-row>
                <el-col>
                  <b-button size="sm" variant="primary" @click="buscar"><i class="fa fa-search"></i> Consultar</b-button>
                  <b-button size="sm" variant="primary" @click="pre_insertar"><i class="fa fa-eraser"></i> Limpiar</b-button>
                  <b-button size="sm" variant="primary" @click="descargarExcel"><i class="fa fa-file-excel-o"></i> Exportar</b-button>
                </el-col> 
              </el-row>                
            </div>
          </div>            

        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Cta Cte Beneficiarios</strong>
          </div>
          <b-row>
            <b-col lg="6"></b-col>

            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input  size="sm"
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12">
              <div ref="refTable">
              <data-tables ref="refTable1"
                :data="data"
                name="table"
                class="table-responsive"
                :current-page.sync="pagina"
                :table-props="tableProps2"
                :filters="filters"
                :page-size="10"
                :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                layout="table"
              >
                <el-table-column
                  v-for="title in titles"
                  :min-width="title.minwidth" 
                  :prop="title.prop"
                  :label='title.label'
                  :key="title.label"
                  :align="title.align"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column label="Modificar" min-width="100px" align="center">
                  <template slot-scope="scope">
                    <el-tooltip
                        v-for="button in customButtonsForRowModif(scope.row)"
                        :key="button.id"
                        :content="button.tooltip"
                        placement="top">
                        <el-button
                          type="text"
                          @click="button.handler"
                        >
                          <i v-bind:class="button.icon"></i>
                          {{ button.name }}
                        </el-button>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </data-tables>
              </div>
            </b-col>
          </b-row>
        </b-card>
      
      </b-col>
    </b-row>


    <!-- Buscar beneficiario -->
    <b-modal
      size="lg"
      ok-only
      title="Beneficiarios"
      cancel-title="Cancelar"
      can
      ok-title="Cerrar"
      no-close-on-backdrop
      no-close-on-esc
      class="modal-success"
      v-model="modalBeneficiarios"
      @ok="modalBeneficiarios = false"
      @cancel="modalBeneficiarios = false"
    >
      
      <b-row>
        <b-col sm="3">  
                <b-form-group
                  label="Código Beneficiario"
                  label-for="codbeneficiarioB"
                >
                <b-form-input 
                  size="sm"
                  id="codbeneficiarioB"
                  type="text"
                  placeholder=""
                  v-model="datosBusqueda.codbeneficiarioB"
                  v-on:keyup="enter">
                </b-form-input>
                
                </b-form-group>
            </b-col>
            <b-col sm="3">
                <b-form-group
                  label="ID Nación Beneficiario"
                  label-for="idnacionB"
                >
                <b-form-input
                  size="sm"
                  id="idnacionB"
                  type="text"
                  placeholder=""
                  v-model="datosBusqueda.idnacionB"
                  v-on:keyup="enter">
                </b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group
                  label="Nombre Beneficiario"
                  label-for="nombreB"
                >
                <b-form-input
                  size="sm"
                  id="nombreB"
                  type="text"
                  placeholder=""
                  v-model="datosBusqueda.nombreB"
                  v-on:keyup="enter">
                </b-form-input>
              </b-form-group>
           </b-col>
           <b-col sm="2">
             <b-form-group
                  label="asdf"
                  label-class="label-blanco"
                  label-for="buscar"
                  color="red"
                >
                <b-button  size="sm" id="buscar" variant="primary" @click="buscarBeneficiario"><i class="fa fa-search"></i> Buscar</b-button>
              </b-form-group>
                
            </b-col>
      </b-row>
      
      <b-row>
            <b-col lg="12">
              <div ref="refTable">
                <data-tables
                  ref="refTable3"
                  :data="data2"
                  name="table"
                  class="table-responsive"
                  :current-page.sync="pagina"
                  :table-props="tableProps2"
                  :filters="filters"
                  :page-size="10"
                  :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                  layout="table"
                >
                  <el-table-column
                    v-for="title in titles2"
                    :min-width="title.minwidth"
                    :prop="title.prop"
                    :label="title.label"
                    :key="title.label"
                    :align="title.align"
                    
                    :formatter="formatter"
                    name="table"
                    class="table-responsive"
                  ></el-table-column>

                  <el-table-column label="Selección" min-width="100px" align="center">
                  <template slot-scope="scope">
                    <el-tooltip
                        v-for="button in customButtonsForRow(scope.row)"
                        :key="button.id"
                        :content="button.tooltip"
                        placement="top">
                        <el-button 
                          type="text"
                          @click="button.handler"
                        >
                          <i v-bind:class="button.icon"></i>
                          {{ button.name }}
                        </el-button>
                    </el-tooltip>
                  </template>
                </el-table-column>
                </data-tables>
              </div>
            </b-col>
          </b-row>
    </b-modal>


    <!-- Editar cuenta -->
    <b-modal
      size="lg"
      title="Modificar"
      cancel-title="Cancelar"
      ok-title="Guardar"
      no-close-on-backdrop
      no-close-on-esc
      class="modal-success"
      v-model="modalEditar"
      @ok="modificar"
      @cancel="modalEditar = false"
    >
      
      <b-row>
        <b-col sm="3">  
          <b-form-group
            label="Moneda">
              <b-form-select
              :options="valMonedas"
              v-model="datosModificacion.codmoneda"
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="datosModificacion.codmoneda=='$'? true: false">
        <b-col sm="5">  
          <b-form-group
            label="Banco">
              <b-form-select
              :options="valBancos"
              v-model="datosModificacion.banco"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col sm="3">  
          <b-form-group
            label="Tipo de Cuenta">
              <b-form-select
              :options="valCuentas"
              v-model="datosModificacion.tipoCuenta"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col sm="4">  
          <b-form-group
            label="Cuenta">
              <b-form-input
                  id="cuenta"
                  type="text"
                  placeholder=""
                  v-model="datosModificacion.cuenta"
                  @change="validarCampo('pkg_sinpp_ctactebene', 'cuenta', $event, 'datosModificacion')">
                </b-form-input>
                <span class="error-validacion-campo">
                    {{ mensajeValidacionCampo.cuenta }}
                </span>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">  
          <b-form-group
            label="Libre">
              <b-form-textarea
                id="libre"
                v-model="datosModificacion.libre"
                placeholder=""
                rows="3"
              ></b-form-textarea>
                <span class="error-validacion-campo">
                    {{ mensajeValidacionCampo.libre }}
                </span>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
    
  </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiGarCtaCteBeneficiario from "@/components/services/apiGarCtaCteBeneficiario";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from 'moment';
import download from "downloadjs";
import Multiselect from 'vue-multiselect';


import XLSX from "xlsx";

export default {
  name: "CtaCteBeneficiarios",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  components: {
    cSwitch
  },
  data: function() {
    return {
      exportar: false,
      tieneAcceso: true,
      es: es,
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      labelIcon: {
        dataOn: "\u2713",
        dataOff: "\u2715"
      },

      modalEditar: false,
      modalBeneficiarios: false,
      data: [],
      data2: [],
      nombreexcel: "CtaCteBeneficiarios",

      titles: [
        
        {
          prop: "NOMBENEF",
          label: "Razón social Beneficiario",
          align: "left",
          minwidth:'250'
        },
        {
          prop: "BENEFICIARIO",
          label: "Código",
          align: "left",
          minwidth:'120'
        },
        {
          prop: "IDNACBENEF",
          label: "ID Nación",
          align: "left",
          minwidth:'120'
        },
        {
          prop: "MONEDA",
          label: "Moneda",
          align: "left",
          minwidth:'120'
        },
        {
          prop: "BANCO",
          label: "Banco",
          align: "left",
          minwidth:'150'
        },
        {
          prop: "TIPOCUENTA",
          label: "Tipo Cuenta",
          align: "left",
          minwidth:'150'
        },
        {
          prop: "CUENTA",
          label: "Cuenta",
          align: "left",
          minwidth:'200'
        },
        {
          prop: "LIBRE",
          label: "Libre",
          align: "left",
          minwidth:'300'
        },
        {
          prop: "MODIFICACION",
          label: "Modificación",
          align: "left",
          minwidth:'150'
        },
        {
          prop: "USUARIO",
          label: "Usuario",
          align: "left",
          minwidth:'150'
        }
      ],
      filters: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
              if (prop === 'MODIFICACION'){
                let elDate = new Date(row["MODIFICACION"])
                let newdate = moment(elDate).add(1, 'days').format('DD/MM/YYYY');
                return newdate.indexOf(filter.value) > -1
              }
              else {
                return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
              }
            })
            
          }
        }
      ],

      titles2: [
        {
          prop: "PERCODIGO",
          label: "Código",
          align: "left",
          minwidth:'80'
        },
        {
          prop: "IDNACION",
          label: "ID Nación",
          align: "left",
          minwidth:'120'
        },
        {
          prop: "PERNOMBRE",
          label: "Nombre",
          align: "left",
          minwidth:'250'
        },
        {
          prop: "PERNACION",
          label: "Nación",
          align: "left",
          minwidth:'80'
        }
      ],

      mostrarFechas: true,
      datosFormulario: {
        codejecutivo: '',
        codbeneficiario: '',
        idnacion: '',
        nombre: '',
        
      },
      datosBusqueda: {
        codbeneficiarioB: '',
        idnacionB: '',
        nombreB: '',
      },

      datosModificacion: {
        codmoneda: "",
        banco: "",
        tipoCuenta: "",
        cuenta: "",
        libre: "",
        modificacion: "",
        usuario: "",
        beneficiario: ""
      },

      valMonedas: [],
      valBancos: [],
      valCuentas: [],
      valEjecutivos: [],
      
      value: null,
      datosFormularioEstado: [],
      datosModificacionEstado: [],

      mensajeValidacionCampo: {},

      tableProps2:{
          summaryMethod: this.totales,
          showSummary: false,
          maxHeight: 400,
          rowKey: "Siniestro"
      },
    };
  },
  components:{
    Datepicker,
    Multiselect
  },
  methods: {
    modificar(){
      this.$Progress.start();

      if (this.datosModificacion.codmoneda == '$'){
        return apiGarCtaCteBeneficiario
        .modificarPeso(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.datosModificacion.beneficiario,
          this.datosModificacion.codmoneda,
          this.datosModificacion.banco,
          this.datosModificacion.cuenta,
          this.datosModificacion.libre,
          this.datosModificacion.tipoCuenta
        )
        .then(response => {
          this.$Progress.finish();
            this.crearNotificacion(
                "Modificar",
                "Datos guardados.",
                "success"
              );
            this.buscar();
          
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
      }else{
        return apiGarCtaCteBeneficiario
        .modificar(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.datosModificacion.beneficiario,
          this.datosModificacion.codmoneda,
          this.datosModificacion.libre
        )
        .then(response => {
          this.$Progress.finish();
            this.crearNotificacion(
                "Modificar",
                "Datos guardados.",
                "success"
              );
            this.buscar();
          
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
      }

    }, 

    enter: function(e) {
      e.preventDefault();
      if (e.keyCode === 13) {
        this.buscarBeneficiario();
      }
    },

    customButtonsForRow(row) {
          var botones = new Array();
          
          var obj = new Object();
            obj.tooltip = "Seleccionar";
            obj.id = 1;
            obj.name="Seleccionar";
            obj.icon = "";
            obj.type = "success";
            obj.handler= _ => {
                this.$session.start();
                this.datosFormulario.codbeneficiario = row.PERCODIGO;
                this.datosFormulario.idnacion = row.IDNACION;
                this.datosFormulario.nombre = row.PERNOMBRE;
                this.modalBeneficiarios = false;
                this.data2 = [];
            }
            botones.push(obj);
          
          return botones;

    },

    customButtonsForRowModif(row) {
          var botones = new Array();
          
          var obj = new Object();
            obj.tooltip = "Modificar";
            obj.id = 1;
            obj.name="";
            obj.icon = "fa fa-edit";
            obj.type = "success";
            obj.handler= _ => {
                
                this.datosModificacion.codmoneda = row.CODMONEDA == undefined? '$': row.CODMONEDA;
                this.datosModificacion.banco = row.CODBANCO;
                this.datosModificacion.tipoCuenta = row.CODTIPOCUENTA;
                this.datosModificacion.cuenta = row.CUENTA;
                this.datosModificacion.libre = row.LIBRE;
                this.datosModificacion.beneficiario = row.BENEFICIARIO;
                this.modalEditar = true;
            }
            botones.push(obj);
          
          return botones;

    },

    buscarBeneficiario (){
      this.$Progress.start();
      //p_email, p_pais, p_nombre, p_idnacion, p_codigo, p_tipo, p_codaseg
      return apiGarCtaCteBeneficiario
        .buscarBeneficiario(
          this.$session.get("mail"),
          '',
          this.datosBusqueda.nombreB, 
          this.datosBusqueda.idnacionB,
          this.datosBusqueda.codbeneficiarioB,
          '',
          1210
        )
        .then(response => {
          this.data2  = response.data.p_res;
          this.pagina = this.paginaAnterior;
          this.$Progress.finish();

          this.datosBusqueda.nombreB = "";
          this.datosBusqueda.idnacionB = "";
          this.datosBusqueda.codbeneficiarioB = "";
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    addTag (newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.options.push(tag)
      this.value.push(tag)
    },

    cambiarFechas(){
      if(this.datosFormulario.selected == 'A') {
            this.mostrarFechas = false;
      }else{
            this.mostrarFechas = true;
      }
    },

    formatNumber(n) {
      console.log(n);
        n = String(n).replace(/\D/g, "");
        return n === '' ? n : Number(n).toLocaleString();
    },

    totales(param) {
 
      const { columns, data } = param;

      const sums = [];

      columns.forEach((column, index) => {
          if (index === 0) {
              sums[index] = 'Total';
              return;
          }

          const values = data.map(item => Number(item[column.property]));

          if (!values.every(value => isNaN(value))) {
              sums[index] = this.$numeral((values.reduce((prev, curr) => {
                  const value = Number(curr);

                  if (!isNaN(value)) {
                      return prev + curr;
                  } else {
                      return prev;
                  }
              }, 0))).format();
             /*
             sums[index] = values.reduce((prev, curr) => {
                  const value = Number(curr);

                  if (!isNaN(value)) {
                      return prev + curr;
                  } else {
                      return prev;
                  }
              }, 0);
              */
          } else {
              sums[index] = '';
          }
      });

      return sums;
    },

    exportarExcel() {
        this.$nextTick(function() {
          var tabla = document.getElementById("tableExcel");
          var data = XLSX.utils.table_to_sheet(tabla);
          const workbook = XLSX.utils.book_new();
          const filename = "Export";
          XLSX.utils.book_append_sheet(workbook, data, filename);
          XLSX.writeFile(workbook, `${filename}.xlsx`);
        });
    },
    
    pre_insertar() {
      this.exportar = false;
      this.mensajeValidacionCampo = {};
      this.data = [];
      this.data2 = [];
      this.value = null;

      return apiGarCtaCteBeneficiario
        .pre_insercion(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno")
        )  
        .then(response => {
          response.data = this.keysMinuscula(response.data);

          //Bloqueo usuario no valido
          if (response.data.args_out.usuarioval == 's'){
            this.tieneAcceso = true;
          }else{
            this.tieneAcceso = false;
          }
          
          var lista_data = response.data.res;
          for(var i = 0; i < lista_data.length; i++){
              this.datosFormulario.codejecutivo = lista_data[i]["codejecutivo"];
              this.datosFormulario.codbeneficiario = "";
              this.datosFormulario.idnacion = "";
              this.datosFormulario.nombre = "";
          }
         
          
          this.datosFormularioEstado = response.data.festado;
          
          

          //Carga lista de monedas
          var tiposMonedas = new Array();
          var lista_tipos_monedas = response.data.monedas;
          for(var i = 0; i < lista_tipos_monedas.length; i++){
              var obj = new Object();
              obj.value = lista_tipos_monedas[i]["tmocodigo"];
              obj.text = lista_tipos_monedas[i]["tmonombre"];
              tiposMonedas.push(obj);
          }
          this.valMonedas = tiposMonedas;

          //Carga lista de bancos
          var tiposBancos = new Array();
          var lista_tipos_bancos = response.data.bancos;
          for(var i = 0; i < lista_tipos_bancos.length; i++){
              var obj = new Object();
              obj.value = lista_tipos_bancos[i]["bcocodigo"];
              obj.text = lista_tipos_bancos[i]["bconombre"];
              tiposBancos.push(obj);
          }
          this.valBancos = tiposBancos;

          //Carga lista de cuentas
          var tiposCuentas = new Array();
          var lista_tipos_cuentas = response.data.cuentas;
          for(var i = 0; i < lista_tipos_cuentas.length; i++){
              var obj = new Object();
              obj.value = lista_tipos_cuentas[i]["codigo"];
              obj.text = lista_tipos_cuentas[i]["nombre"];
              tiposCuentas.push(obj);
          }
          this.valCuentas = tiposCuentas;
          
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    buscar() {
      this.$Progress.start();

      
      return apiGarCtaCteBeneficiario
        .recuperar(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.datosFormulario.codbeneficiario == ''? '0': this.datosFormulario.codbeneficiario
        )
        .then(response => {
          this.data  = response.data.res;
          this.pagina = this.paginaAnterior;
          this.$Progress.finish();
          
          if (this.data != null){
            this.exportar = true;
          } else {
            this.exportar = false;
          }
          
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    formatter(row, column) {
      
      if ((column.property == "MODIFICACION"
          ) && row[column.property]) {
        return this.configurarFechaLat(this.convierteFecha(row[column.property]));
      }
      else if ((column.property == "Monto Indemnizado en MonPol" ||
                column.property == "Monto Impago Inicial en MonPol" ||
                column.property == "Devolución recuperos en MonPol" ||
                column.property == "Coaseguro" ||
                column.property == "Parte Cubierta"
      ) && row[column.property]) {
        column.align = "is-right";
        if (row[column.property] == 0 || row[column.property] == "0"){
          return row[column.property];
        }else{
          return this.$numeral(row[column.property]).format('0,0.00');
        }
      }
      else if ((column.property == "Monto Impago" ||
                column.property == "Monto Indemnizado en CLP" ||
                column.property == "Devolución recuperos en CLP" ||
                column.property == "Número de Casos" ||
                column.property == "Activo" ||
                column.property == "Cerrado" ||
                column.property == "Desistido" ||
                column.property == "Indemnizado" ||
                column.property == "Plan de Pago" ||
                column.property == "Rechazado" ||
                /*
                column.property == "Anulado" ||
                column.property == "Apelado" ||
                column.property == "Doc. Incompletos" ||*/
                column.property == "Indemnizaciones" ||
                column.property == "Devoluciones" ||
                column.property == "Inf. Liq. Pendiente" ||
                column.property == "Casos Castigados" ||
                column.property == "Casos Excepcionados"
               ) && row[column.property]){
        column.align = "is-right";
        if (row[column.property] == 0 || row[column.property] == "0"){
          return row[column.property];
        }else{
          return this.$numeral(row[column.property]).format();
        }
      }
      else {
        return row[column.property];
      }
    },

    descargarExcel: function(){
      var cuerpo = "";
      var columnas = this.titles;

      var xl159618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl689618 = "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; background:#BDD7EE; mso-pattern:black none; white-space:nowrap;";
      var xl649618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl679618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl719618 = "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap; mso-rotate:90;";
      var xl659618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";

      cuerpo += "<table border=0 cellpadding=0 cellspacing=0 width=730 style='border-collapse:collapse;table-layout:fixed;width:550pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=32 style='mso-width-source:userset;mso-width-alt:1170;width:24pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=130 style='mso-width-source:userset;mso-width-alt:4754;width:98pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=61 span=8 style='mso-width-source:userset;mso-width-alt:2230; width:46pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=80 style='width:60pt'>";
      cuerpo += "\n";

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
        cuerpo += "<td height=28 class=xl159618 width=32 style='height:21.0pt;width:24pt;"+xl159618+"'></td>\n";
        cuerpo += "<td colspan="+columnas.length+" class=xl689618 width=698 style='width:526pt;"+xl689618+"'>Cta Cte Beneficiarios</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
        cuerpo += "<td height=20 class=xl159618 style='height:15.0pt;"+xl159618+"'></td>\n";
        for (var i=0; i<columnas.length; i++) {
          cuerpo += "<td class=xl679618 style='border-left:none;"+xl679618+"'>"+columnas[i].label+"</td>\n";
        }
      cuerpo += "</tr>\n";


      //Data bloque 1
      for (var key in this.data) {
          
          if(this.data[key]["PRODUCTO"] == undefined){
              this.data[key]["PRODUCTO"] = "";
          }
          if(this.data[key]["EJECUTIVO"] == undefined){
              this.data[key]["EJECUTIVO"] = "";
          }
          if(this.data[key]["NOMBENEF"] == undefined){
              this.data[key]["NOMBENEF"] = "";
          }
          if(this.data[key]["BENEFICIARIO"] == undefined){
              this.data[key]["BENEFICIARIO"] = "";
          }
          if(this.data[key]["IDNACBENEF"] == undefined){
              this.data[key]["IDNACBENEF"] = "";
          }
          if(this.data[key]["MONEDA"] == undefined){
              this.data[key]["MONEDA"] = "";
          }
          if(this.data[key]["BANCO"] == undefined){
              this.data[key]["BANCO"] = "";
          }
          if(this.data[key]["TIPOCUENTA"] == undefined){
              this.data[key]["TIPOCUENTA"] = "";
          }
          if(this.data[key]["CUENTA"] == undefined){
              this.data[key]["CUENTA"] = "";
          }
          if(this.data[key]["LIBRE"] == undefined){
              this.data[key]["LIBRE"] = "";
          }
          if(this.data[key]["MODIFICACION"] == undefined){
              this.data[key]["MODIFICACION"] = "";
          }
          if(this.data[key]["USUARIO"] == undefined){
              this.data[key]["USUARIO"] = "";
          }
          

          cuerpo += "<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
            cuerpo += "<td>&nbsp</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["PRODUCTO"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["EJECUTIVO"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["NOMBENEF"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["BENEFICIARIO"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["IDNACBENEF"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["MONEDA"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["BANCO"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["TIPOCUENTA"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["CUENTA"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["LIBRE"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"mso-number-format:\"\@\"''  >"+this.convierteFecha(this.data[key]["MODIFICACION"])+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["USUARIO"]+"</td>\n";
            
          cuerpo += "</tr>\n";
      }

      this.export(this.generaExcelV2(this.nombreexcel, cuerpo),this.nombreexcel);
    },

    export:async function(data, filename) {
      if(typeof this.beforeFinish === 'function')
        await this.beforeFinish();
      download(data, filename,  "application/vnd.ms-excel");
    },
    
    convierteFecha(fechaEntrada){
        if((fechaEntrada != undefined) && (fechaEntrada.length != 0)){
            var fecha = new Date(fechaEntrada);

            var dia = ("0" + fecha.getUTCDate()).slice(-2);
            var mes = ("0" + (fecha.getUTCMonth() + 1)).slice(-2)
            var año = fecha.getUTCFullYear();

            fecha = dia + '-' + mes + '-' + año;

            return fecha;
        }
        else{
            return fechaEntrada;
        }
    },
  },
  mounted() {
    this.pagina = Number(this.$route.query.pagina);
    this.pre_insertar();
  },

  watch: {
    pagina: function(nuevo, anterior) {
      this.paginaAnterior = anterior;
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
  .multiselect__tag {
    background: #20a8d8 !important;
  }
  .multiselect__option--highlight:after {
    background: #20a8d8 !important;
  }

  .multiselect__option--highlight {
    background: #20a8d8 !important;
}
.multiselect__tags {
    border-radius: 0px !important;
    min-height: 70px !important;
}

.label-blanco{
  color: #fff;
}
</style>
